export class MarketingConsentWithdrawalStorageSerializer {
    serializeForStorage(data) {
        return JSON.stringify(data);
    }
    deserializeFromStorage(data) {
        try {
            const info = JSON.parse(data);
            this.assertValid(info);
            return info;
        }
        catch (error) {
            return null;
        }
    }
    assertValid(data) {
        if (typeof data !== "object" ||
            data === null ||
            !("email" in data) ||
            !("phone" in data) ||
            typeof data.email !== "string" ||
            typeof data.phone !== "string") {
            throw new Error("Invalid marketing consent withdrawal data");
        }
    }
}
